import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { setAnalyticTeams } from '../../../../state/analytic/analyticTeamSlice';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchTeamSaga(action) {
    try {
        const { data } = yield call([backendClient, backendClient.get], 'teams');
        yield put(setAnalyticTeams(data));
    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to fetch analytic team', status, err?.message);
    }
}